document.addEventListener('DOMContentLoaded', function () {
  var glow = document.createElement('div');
  glow.id = 'site-cursor-glow';
  document.body.appendChild(glow);

  var mouseX = 0, mouseY = 0, glowX = 0, glowY = 0;

  window.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
  });

  function animateGlow() {
    glowX += (mouseX - glowX) * 0.12;
    glowY += (mouseY - glowY) * 0.12;
    glow.style.transform = 'translate(' + (glowX - 210) + 'px,' + (glowY - 210) + 'px)';
    requestAnimationFrame(animateGlow);
  }
  requestAnimationFrame(animateGlow);

  if (window.matchMedia('(hover: hover)').matches) {
    var tiltTargets = document.querySelectorAll('.card, .bsc-card, .tst-card');
    tiltTargets.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5;
        var py = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(600px) rotateX(' + (-py * 6) + 'deg) rotateY(' + (px * 6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }
});
